const ignoredErrorPatterns = [
  /^Script error:/,
  /^(ReferenceError: )?Can't find variable: IntersectionObserver/,
];

export default ignoredErrorPatterns;
